module.exports = __webpack_public_path__ + "static/media/TheWestHomeOfGrandFinalLogo.71b53703.png";